export function suspend<T>(promisable: PromiseLike<T> | T): T {
  if (promisable instanceof Promise) {
    throw promisable
  }

  return promisable as T
}
